import { render } from "./_Etapa1.vue?vue&type=template&id=6ce63a72&scoped=true"
import script from "./_Etapa1.vue?vue&type=script&lang=ts"
export * from "./_Etapa1.vue?vue&type=script&lang=ts"

import "./_Etapa1.vue?vue&type=style&index=0&id=6ce63a72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ce63a72"

export default script